export interface FBFormModel {
  id?: number;
  baseDocFileID?: number;
  baseDocHTML?: string;
  formTypeID?: number;
  name?: string;
  description?: string;
  inactive?: boolean;
  createdDate?: string;
  baseDocFile?: FBDocFileModel;
  formType?: FBFormTypeModel;
  formFields?: FBFormFieldModel[];

  required?: boolean;
  requireHRSignature?: boolean;
  isAutoAssignable?: boolean;
  reAssignAfterDays?: number;
  shouldAssignAsDefault?: boolean;
  isCredentialDoc?: boolean;
  requiredForAuthorizationCategoryIDs?: string;
  isForAdult?: boolean;
  isForChild?: boolean;
  dueInDays?: number;

  formFieldGroups?: FBFormFieldGroupModel[];

  formLanguages?: FBFormLanguageModel[];
}
export interface FormViewModel {
  formID?: number;
  formName?: string;
  formDescription?: string;
  isForAdult?: boolean;
  isForChild?: boolean;
  
}

export interface FBFormFieldModel {
  id?: number;
  fieldName?: string;
  fieldDescription?: string;
  fieldTypeID?: number;
  fieldSize?: number;
  minLength?: number;
  fieldGroup?: string;
  fieldOrder?: number;
  fieldOptions?: string;
  fieldWidthRatio?: number;
  isRequired?: boolean;
  getFromMapped?: boolean;
  saveOnMapped?: boolean;
  needApproval?: boolean;
  fieldMapTable?: string;
  fieldMapColumn?: string;
  pDFFieldName?: string;
  inactive?: boolean;
  createdDate?: string;
  formFieldType?: FBFormFieldTypeModel;
  allowOther?: boolean;
  readOnly?: boolean;
  isHistoricalField?: boolean;
  notFillableByClient?: boolean;
  hideLabel?: boolean;
  tooltip?: string;
  showAsDropdown?: boolean;
  defaultText?: string;
  calculatedRelatedFieldIDs?: string;
  optionsTable?: string;

  minValue?: number;
  maxValue?: number;

  
  //--LOCAL
  localID?: number;
  opened?: boolean;

  relatedFormFieldID?: number;
  showIfRelatedAnswerIs?: string;
  requiredIfFieldID?: number;
  requiredIfFieldAnswerIs?: string;
  formFieldGroupID?: number;

  repeat?: boolean;
  minItems?: number;
  sectionFields?: FBFormFieldModel[];
  sections?: FBFormFieldSection[];

  sectionFormFieldID?: number;
  formControlIdentifier?: string;
  entryNumber?: number;

  formFieldLanguages?: FBFormFieldLanguageModel[];
}

export interface FBFormFieldSection {
  entryNumber: number;
  readOnly: boolean;
  formFields: FBFormFieldModel[];
}

export interface FBDocFileModel {
  id?: number;
  fileDate?: string;
  fileName: string;
  fileType: string;
  fileAwsBucket: string;
  fileAwsKey: string;
  fileSize?: number;
}

export interface FBFormTypeModel {
  id?: number;
  formType: string;
}

export interface FBFormFieldValueModel {
  id?: number;
  formSubmissionID?: number;
  formFieldID?: number | string;
  formField?: FBFormFieldModel;
  value: string;
  createdDate?: string;
  fileName?: string;
  fileDownloadUrl?: string;
  entryNumber?: number;
  readOnly?: boolean;
}

export interface FBFormFieldTypeModel {
  id?: number;
  formFieldType: string;
}

export interface FBFormAssignmentModel {
  id?: number;
  inquiryID?: number;
  formID?: number;
  formSubmissionID?: number;
  form?: FBFormModel;
  formSubmission?: FBFormSubmissionModel;
  isRequired?: boolean;
  isSkipped?: boolean;
  dueDate?: string;
  createdDate?: string;
  revokedDate?: string;
  canOptOut?: boolean;

  userIDs?: number[];
}

export interface FBFormSubmissionModel {
  id?: number;
  formID?: number;
  userID?: number;
  inquiryID?: number;
  patientResponsibilityAccountID?: number;
  generatedDocFileID?: number;
  documentToSignID?: number;
  createdDate?: string;
  fbFormFieldValues?: FBFormFieldValueModel[];
  fbForm?: FBFormModel;
  updatedDate?: string;
  signedDate?: string;
  optOutDate?:string;
  isAutoAssigned?: boolean;
  isRequired?: boolean;
  acknowledgedDate?: string;
  languageID?: number;
}

export interface FBFormFieldGroupModel {
  id?: number;
  formID?: number;
  groupName?: string;
  order?: number;

  formFieldGroupLanguages?: FBFormFieldGroupLanguageModel[];
}


export interface FBFormLanguageModel {
  id?: number;
  baseDocFileID?: number;
  baseDocHTML?: string;
  baseSummaryDocHTML?: string;
  name?: string;
  description?: string;
  baseDocFile?: FBDocFileModel;
  languageID?: number;
  formID?: number;
  languageName?: string;
  languageCode?: string;
}

export interface FBFormFieldLanguageModel {
  id?: number;
  fieldDescription?: string;
  fieldOptions?: string;
  tooltip?: string;
  defaultText?: string;
  languageID?: number;
  formFieldID?: number;
}


export interface FBFormFieldGroupLanguageModel{
  id?: number;
  groupName?: string;
  tooltip?: string;
  languageID?: number;
  formFieldGroupID?: number;
}


export interface FormAssignmentViewModel {
  formAssignmentID?: number;
  inquiryID?: number;
  formID?: number;
  formSubmissionID?: number;
  documentToSignID?: number;
  
  isRequired?: boolean;
  createdDate?: Date;
  signedDate?: Date;
  optOutDate?: Date;

  isSkipped?: boolean;
  canOptOut?: boolean;
  assignmentLoginID?: number;
  assignmentLoginDisplayName?: string;
  isLoginScoped?: boolean;
  canSplitByPortalLogin?: boolean;
  formName?: string;
  formDescription?: string;
  revokedDate?: Date;

  // Intake packet metadata (grouping)
  intakeTier?: number;
  isCoreIntakeDoc?: boolean;
  isCoreMedClinicIntakeDoc?: boolean;

  // Company-level packet info for display
  intakePacketWindowDays?: number;
  intakePacketResignIntervalDays?: number;

  isPortalAccessRestricted?: boolean;
  portalAccessRestrictionMessage?: string;

}
